import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { EnvironmentService } from '@app/core/environment/environment.service';
import { DatadogSettings } from '@app/core/environment/datadog.model';
import { Ianalytics, IdatadogMessage, IdatadogMessageFormatted } from '@app/shared/model/datadog-message';
import { SdkAnalyticsService } from '@app/shared/services/sdk-analytics/sdk-analytics.service';
import { DatadogConfig } from '@app/shared/interface/sdk-analytics';

@Injectable({
  providedIn: 'root'
})
export class DatadogService {
  private envDatadog: DatadogSettings;

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService,
    private sdkAnalyticsService: SdkAnalyticsService
  ) {}

  public isInternalNetwork(url: string): Observable<boolean> {
    return this.http.get(url+ '/hello', { responseType: "json" }).pipe(
      map(() => true), // Return true if status code is 200
      catchError((error: HttpErrorResponse) => {
        if ( error.status === 200 ) {
          return of(true); // Return true if status code is 200
        }
        return of(false); // Return false for other errors
      })
    );
  }

  public configureDataDog() {

    // get env do en4 --- en4
    this.environmentService
      .loadEnvironment()
      .subscribe(res => {
        this.envDatadog = res.datadogSettings //set env
        // --- en4

        // --- datadog
        this.isInternalNetwork(this.envDatadog.ddproxy)
        .subscribe(internal => {
          console.log('isInternalNetwork',internal);
          this.initializeDatadog(internal);
        });
        // --- datadog

      // --- en4
      })
      // --- en4

  }

  private initializeDatadog(internal: boolean) {
    const config: DatadogConfig = {
      name: this.envDatadog.name,
      version: this.envDatadog.version,
      env: this.envDatadog.environment,
      sigla: this.envDatadog.sigla,
      datadog: {
        logs: {
          clientToken: this.envDatadog.proxyToken,
          proxy: internal ? this.envDatadog.ddproxy : undefined,
          maskSensitiveData: true
        },
        rum: {
          applicationId: this.envDatadog.applicationId,
          clientToken: this.envDatadog.proxyToken,
          sessionSampleRate: this.envDatadog.sessionSampleRate,
          proxy: internal ? this.envDatadog.ddproxy : undefined,
          trackViewsManually: true,
          maskSensitiveData: true
        }
      },
      externalApplication: false,
    };

    if (!internal) {
      config.datadog.logs.clientToken = this.envDatadog.clientTokenExt;
      config.datadog.rum.clientToken = this.envDatadog.clientTokenExt;
      config.externalApplication = true;
    }

    this.sdkAnalyticsService.configureDatadog(config);
  }



  /**
   * Método que envia o erro para o datadog via SDK.
   * @param {string} message - mensagem que será enviada para ferramenta.
   * @param {object} context - contexto adicional do erro.
   */
  public sendErrorLogs(message: string, context: Record<string, unknown> = {}) {
    this.sdkAnalyticsService.sendDatadogErrorLog(message, context);
  }

  /**
   * Método que envia o log informativo para o datadog via SDK.
   * @param {string} message - mensagem que será enviada para ferramenta.
   * @param {object} context - contexto adicional do log.
   */
  public logInfo(message: string, context: Record<string, unknown> = {}) {
    this.sdkAnalyticsService.sendDatadogInfoLog(message, context);
  }

  /**
   * Método que envia o view para o datadog RUM via SDK.
   * @param {string} pagina - nome da página.
   * @param {object} contexto - contexto adicional da view.
   */
  public sendStartView(pagina: string, contexto?: Record<string, unknown>) {
    this.sdkAnalyticsService.sendDatadogStartView(pagina, contexto || {});
  }

  /**
   * Método que envia o user para o datadog RUM via SDK.
   * @param {string} _id - ID do usuário.
   * @param {string} _name - nome do usuário.
   */
  public sendSetUser(_id: string, _name?: string) {
    this.sdkAnalyticsService.sendDatadogSetUser(_id, _name);
  }

  /**
  * Método utilizado pelo MFE para enviar logs de erro para o datadog.
  */
  public sendErrorLogsChildren(payload: IdatadogMessage): void {
    const analytics = payload.analytics;

    if (!this.validatePayload(analytics, 'dd')) return;

    const {message, context} = this.formatMessage(analytics);
    this.sendErrorLogs(message, context);
  }

  private validatePayload(payload: Ianalytics, key: string): boolean {
    return payload && typeof payload === 'object' && key in payload;
  }

  private formatMessage(payload: Ianalytics): IdatadogMessageFormatted {
    const { applicationUrl, statusCode, name, erro, api, ambiente } = payload.dd,
    message = `status: ${statusCode} nome-mfe: ${name} url: ${applicationUrl}`,
    context = { erro: `${erro}, api: ${api}, ambiente: ${ambiente}`, name };

    return { message, context };
  }
}
